/*
 * Efeito "voar para o carrinho" (Lagai) — versao unica e compartilhada.
 * Ao clicar em Adicionar, uma miniatura da foto do produto voa ate o icone do
 * carrinho no header. Puramente visual: NAO chama preventDefault e nao toca na
 * logica de add-to-cart do tema. Delegado no document; cobre varios contextos:
 *
 *   Carrossel da home / grade "Todos os produtos" (card Lagai): button.pcz__atc
 *   Card "Adicionar" de largura cheia:                           button.card-atc
 *   Hero PDP 2.0:                                                button.hpn__atc
 *   Barra fixa da PDP:                                           .hpnbar__btn
 *
 * Observacao: os botoes acima usam <product-form-component> (custom), entao o
 * fly-to-cart NATIVO do tema (add-to-cart-component) nao dispara neles — sem
 * duplicacao.
 */
(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bumpCart(cartIcon) {
    cartIcon.style.transition = 'transform .18s ease';
    cartIcon.style.transform = 'scale(1.18)';
    setTimeout(function () { cartIcon.style.transform = ''; }, 190);
  }

  function fly(imgEl) {
    if (REDUCE || !imgEl) return;
    var cartIcon = document.querySelector('.header-actions__cart-icon, cart-icon, [data-testid="cart-icon"]');
    if (!cartIcon) return;
    var i = imgEl.getBoundingClientRect();
    var c = cartIcon.getBoundingClientRect();
    if (!i.width || !c.width) return;

    var size = Math.min(i.width, i.height, 120);
    var sx = i.left + i.width / 2 - size / 2;
    var sy = i.top + i.height / 2 - size / 2;
    var ex = c.left + c.width / 2 - size / 2;
    var ey = c.top + c.height / 2 - size / 2;

    var el = document.createElement('img');
    el.src = imgEl.currentSrc || imgEl.src;
    el.setAttribute('aria-hidden', 'true');
    el.style.cssText =
      'position:fixed;left:0;top:0;width:' + size + 'px;height:' + size + 'px;' +
      'object-fit:cover;border-radius:14px;z-index:9999;pointer-events:none;' +
      'box-shadow:0 10px 26px rgba(0,0,0,.18);' +
      'transform:translate(' + sx + 'px,' + sy + 'px) scale(1);opacity:1;' +
      'transition:transform .8s cubic-bezier(.6,.04,.3,1),opacity .8s ease,border-radius .8s ease;' +
      'will-change:transform,opacity;';
    document.body.appendChild(el);
    el.getBoundingClientRect(); /* reflow */

    requestAnimationFrame(function () {
      el.style.transform = 'translate(' + ex + 'px,' + ey + 'px) scale(' + (24 / size) + ')';
      el.style.opacity = '0.35';
      el.style.borderRadius = '50%';
    });

    var done = false;
    function cleanup() {
      if (done) return;
      done = true;
      el.removeEventListener('transitionend', cleanup);
      el.remove();
      bumpCart(cartIcon);
    }
    el.addEventListener('transitionend', cleanup);
    setTimeout(cleanup, 1000); /* fallback */
  }

  function resolveImage(btn) {
    /* Card Lagai (carrossel da home e grade da colecao) */
    var pcz = btn.closest('.pcz__card');
    if (pcz) return pcz.querySelector('img.pcz__img');

    /* Barra fixa da PDP: usa a miniatura visivel da propria barra */
    var bar = btn.closest('.hpnbar');
    if (bar) return bar.querySelector('.hpnbar__thumb img');

    /* "Leve junto" da PDP: usa a miniatura do proprio item */
    var lj = btn.closest('.hpn__lj-item, .hpn__lj-wrap');
    if (lj) return lj.querySelector('.hpn__lj-thumb img');

    /* Hero PDP 2.0: imagem do slide ativo */
    if (btn.classList.contains('hpn__atc')) {
      var hero = document.querySelector('[data-hpn]');
      if (hero) return hero.querySelector('.hpn__slide.is-active img') || hero.querySelector('.hpn__slide img');
    }

    /* Card generico (card-atc etc.): sobe ate o container e pega a 1a imagem "grande" */
    var card = btn.closest('li, .card, .product-card, .card-wrapper, .product-grid__item, .grid__item, article');
    if (card) {
      var imgs = card.querySelectorAll('img');
      for (var k = 0; k < imgs.length; k++) {
        var r = imgs[k].getBoundingClientRect();
        if (r.width >= 40 && r.height >= 40) return imgs[k];
      }
      if (imgs.length) return imgs[0];
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    /* Ignora cliques sinteticos (ex.: a barra fixa faz atcBtn.click() na hero),
       para nao disparar dois efeitos. */
    if (!e.isTrusted) return;
    var btn = e.target.closest('button.pcz__atc, button.card-atc, button.hpn__atc, button.hpn__lj-btn, .hpnbar__btn');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var img = resolveImage(btn);
    if (img) fly(img);
  }, false);

  window.LagaiFlyToCart = fly;
})();
